<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      :searchShow="true"
      :searchMenuSpan="4"
      :searchBtnText="''"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      @row-save="save"
      @row-update="update"
      @row-del="del"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getPcRemindAndInform, savePcRemindAndInform, removePcRemindAndInform } from '@/api/health/manage'

export default {
  data() {
    return {
      form: {},
      channel: window.localStorage.getItem('channel'),
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      params: {},
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: '序号',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        editBtn: true,
        addBtn: true,
        delBtn: true,
        selection: true,
        searchMenuSpan: 4,
        menuWidth: 200,

        column: [
          {
            label: '提醒类型',
            prop: 'remindType',
            type: 'select',
            search: true,
            dicData: [
              { label: '用药提醒', value: '用药提醒' },
              { label: '定期体检提醒', value: '定期体检提醒' },
              { label: '复诊专家提醒', value: '复诊专家提醒' },
              { label: '检查检验提醒', value: '检查检验提醒' }
            ],
            searchSpan: 5
          },
          {
            label: '发送时间',
            prop: 'remindDate',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            label: '客户姓名',
            prop: 'name',
            search: true,
            searchSpan: 5
          },
          {
            label: '提醒标题',
            prop: 'title'
          },
          {
            label: '提醒内容',
            prop: 'content'
          },
          {
            label: '联系电话',
            prop: 'phone',
            search: true,
            searchSpan: 5
          },
          {
            label: '用药/检查日期',
            prop: 'medicalDate',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            label: '是否陪诊',
            prop: 'isFollow',
            type: 'select',
            search: true,
            width: 80,
            dicData: [
              { label: '否', value: '否' },
              { label: '是', value: '是' }
            ],
            searchSpan: 5
          },
          {
            label: '上次记录',
            prop: 'record'
          }
        ]
      },
      data: [
        {
          type: 0,
          sendTime: '2025-10-29',
          userName: '郭苗苗',
          title: '奥斯特为',
          content: '30mg/日',
          userPhone: '13331336208',
          date: '2025-10-29',
          isPei: 1,
          history: ''
        },
        {
          type: 1,
          sendTime: '2025-10-29',
          userName: '郭苗苗',
          title: '全身体检',
          content: '南京市xx医院',
          userPhone: '13331336208',
          date: '2025-10-29',
          isPei: 1,
          history: ''
        },
        {
          type: 2,
          sendTime: '2025-10-29',
          userName: '郭苗苗',
          title: 'XX主任',
          content: '南京市XX医院XX科室',
          userPhone: '13331336208',
          date: '2025-10-29',
          isPei: 1,
          history: '贫血'
        },
        {
          type: 3,
          sendTime: '2025-10-29',
          userName: '郭苗苗',
          title: '例颈动脉彩超',
          content: '南京市XX医院XX科室',
          userPhone: '13331336208',
          date: '2025-10-29',
          isPei: 1,
          history: ''
        }
      ]
    }
  },
  computed: {},
  methods: {
    onLoad(page, params) {
      params.channel = this.channel
      getPcRemindAndInform(page.currentPage, page.pageSize, params).then(res => {
        this.page.total = res.data.total
        this.data = res.data.remindAndInform
        console.log(res.data)
      })
    },

    save(row, done, loading) {
      row.channel = this.channel
      savePcRemindAndInform(row)
        .then(res => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('添加成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    update(row, index, done, loading) {
      savePcRemindAndInform(row)
        .then(res => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('修改成功!')
        })
        .catch(res => {
          this.$message.error('修改失败!')
          this.onLoad(this.page, this.params)
        })
    },

    del(row, done, loading) {
      removePcRemindAndInform(row)
        .then(res => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('删除成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem('channel')
      }
      this.onLoad(this.page, this.params)
    },

    searchChange(params, done) {
      params.channel = window.localStorage.getItem("channel");
      this.params = params;
      this.page.currentPage = 1;
      console.log(params)
      this.onLoad(this.page, params);
      done();
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    }
  }
}
</script>

<style scoped>
/* 全局样式，确保搜索按钮与搜索框在同一行 */
.el-form--inline .el-form-item {
  margin-bottom: 15px;
  display: inline-flex;
  align-items: flex-end;
}

/* 搜索按钮不单独成行 */
.avue-search-button {
  display: inline-block;
  margin-left: 10px;
  margin-bottom: 15px;
  vertical-align: bottom;
}

/* 调整搜索框布局 */
.avue-crud__search {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.avue-crud__search .el-form--inline {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  width: 100%;
}

.avue-crud__search .el-form--inline > * {
  display: inline-flex;
  align-items: center;
}
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
